import { SYMBOL_ASYNC_ITERATOR } from "../polyfills/symbols.mjs";
/**
 * Returns true if the provided object implements the AsyncIterator protocol via
 * either implementing a `Symbol.asyncIterator` or `"@@asyncIterator"` method.
 */

// eslint-disable-next-line no-redeclare
export default function isAsyncIterable(maybeAsyncIterable) {
  return typeof (maybeAsyncIterable === null || maybeAsyncIterable === void 0 ? void 0 : maybeAsyncIterable[SYMBOL_ASYNC_ITERATOR]) === 'function';
}



//////////////////
// WEBPACK FOOTER
// ./~/graphql/jsutils/isAsyncIterable.mjs
// module id = Lq0W
// module chunks = 9